import React from "react";
import "./Blog.css";
import pic from "../../assets/Group 40.png";
const Blog = () => (
  <div className='blog__container section__padding' id='blog'>
    <img src={pic} />
  </div>
);

export default Blog;
